import register from "preact-custom-element";
import { useState, useEffect } from "preact/hooks";

import FindNearby from "./find-nearby";

const endpointUrl = `${window.BARREL.sbdApiUrl}/serviceCenterLocator`;
const token = window.BARREL.sbdApiAccessToken;

const googleApiKey = window.BARREL.googleApiKey;
const googleDirectionsUrl = window.BARREL.googleDirectionsUrl;

const defaultLocation = {
  lat: parseFloat(window.BARREL.defaultLocationLat),
  lng: parseFloat(window.BARREL.defaultLocationLng),
};
const defaultUnit = window.BARREL.defaultUnit;
const defaultPageSize = parseInt(window.BARREL.defaultPageSize);

const debounceTimeout = 500;

const ServiceCenter = () => {
  // Location

  const [currentLocation, setCurrentLocation] = useState(defaultLocation);
  const [loading, setLoading] = useState(true);

  const getCurrentLocation = () => {
    if (navigator && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((pos) => {
        if (pos) {
          const coords = pos.coords;
          return {
            lat: coords.latitude,
            lng: coords.longitude,
          };
        }
      });
    }

    return defaultLocation;
  };

  useEffect(() => {
    let loc = defaultLocation;
    const { lat, lng } = getCurrentLocation();

    if (lat && lng) {
      loc = {
        lat,
        lng,
      };
    }

    if (loc.lat !== currentLocation.lat || loc.lng !== currentLocation.lng) {
      setCurrentLocation(loc);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentLocation) {
      getLocatorData(currentLocation);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLocation]);

  // Service Center

  const [locatorData, setLocatorData] = useState([]);
  const [pageLocator, setPageLocator] = useState(1);
  const [pageSizeLocator] = useState(defaultPageSize);
  const [numberOfRecords, setNumberOfRecords] = useState("");
  const [radius, setRadius] = useState("");
  const [type, setType] = useState("");
  const [market, setMarket] = useState("");
  const [brandName, setBrandName] = useState("");
  const [totalLocator, setTotalLocator] = useState(0);
  const [loadingLocator, setLoadingLocator] = useState(false);
  const [vendorName, setVendorName] = useState("");

  const updateLocatorData = (json) => {
    setLoadingLocator(false);

    if (!json) {
      return;
    }

    const total = json.total;
    setTotalLocator(total);

    let data = [...locatorData, ...json.data];

    if (data && data.length > 0) {
      data = data.map((e) => {
        if (e.coordinates) {
          let [latitude, longitude] = e.coordinates
            .split(",")
            .map((e) => parseFloat(e.trim() || 0));
          e.coordinates = { latitude, longitude };
        }
        return e;
      });
    }

    setLocatorData(data);

    setLoading(false);
  };

  const getLocatorData = (location) => {
    console.log({ endpointUrl, token });
    let url = `${endpointUrl}/find?token=${token}&numberOfRecordsRequired=${numberOfRecords}&distanceUnit=${defaultUnit}&brandName=${brandName}&radius=${radius}&type=${type}&currentMarket=${market}`;

    if (vendorName && vendorName.length > 0) {
      url += `&filterField=vendorName&filterValue=${encodeURIComponent(
        vendorName
      )}`;
    }

    if (location) {
      url += `&latitude=${location.lat}&longitude=${location.lng}`;
    }

    try {
      setLoadingLocator(true);

      fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          if (res.status === 200) {
            return res.json();
          }

          return null;
        })
        .then((json) => {
          if (json) {
            updateLocatorData(json);
          } else {
            updateLocatorData(null);
          }
        })
        .catch((error) => {
          console.log(error.message);
          updateLocatorData(null);
        });
    } catch (error) {
      console.log(error.message);
      updateLocatorData(null);
    }
  };

  const nextLocator = () => {
    const pageCount = Math.ceil(totalLocator / pageSizeLocator);

    if (pageLocator < pageCount) {
      setPageLocator(pageLocator + 1);
      getLocatorData(currentLocation);
    }
  };

  const resetData = () => {
    setLocatorData([]);
    setPageLocator(1);
  };

  useEffect(() => {
    if (!loading) {
      getLocatorData(currentLocation);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendorName]);

  const locationChanged = (location) => {
    resetData();

    if (
      location.lat !== currentLocation.lat ||
      location.lng !== currentLocation.lng
    ) {
      setCurrentLocation(location);
    }
  };

  const debounce = (func, timeout = debounceTimeout) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  };

  const updateVendorName = (name) => {
    if (name === vendorName) {
      return;
    }

    resetData();
    setVendorName(name);
  };

  const vendorNameChanged = debounce((name) => updateVendorName(name));

  return (
    <div class="min-h-[700px] px-6 text-center overflow-hidden">
      <div class="px-0 md:pt-3">
        <div class="md:text-left text-black h2 font-bold mb-4 mt-8">
          Service Centers
        </div>
      </div>

      <div>
        <FindNearby
          data={locatorData}
          load={nextLocator}
          loading={loadingLocator}
          total={totalLocator}
          nameChanged={vendorNameChanged}
          currentLocation={currentLocation}
          locationChanged={locationChanged}
          defaultUnit={defaultUnit}
          apiKey={googleApiKey}
          directionsUrl={googleDirectionsUrl}
        />
      </div>
    </div>
  );
};

register(ServiceCenter, "service-center", [], { shadow: false });
